import React, { Component } from "react";
import Store from "../../content/Store";
import ShadowedContainer from "./../shared/containers/ShadowedContainer";
import Article from "../shared/Article";
import HelpSection from "./../shared/HelpSection";
// import { PromoImageCard } from "../shared/PromoImageCard";
import  MskSection  from "../shared/MskSection";
// import { Paths } from "../../constants/UrlConstants";
import Button from "../shared/buttons/Button";
import PromoContainer from "../shared/containers/PromoContainer";
import style from "../../assets/css/modules/claims/claims.css";
import claimRowStyle from "../../assets/css/modules/claims/claims-summary-desktop-row.css";
import Content from "../../content/Content";
import DropDown from "../shared/form/DropDown";
import Contentify from "../../content/Contentify";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Breakpoints } from "../../constants/CssConstants";
import {
  setClaimMembers,
  setClaimSummaryForMember,
  setClaimCondition,
  getMemberDetails
} from "../../actions/claims/claimsActions";
import { EPDomain_ROOT } from "../../constants/EP-config";
import EPQueryParams from "../../constants/EPQueryParams";
import ClaimsSummaryContainer from "./ClaimsSummaryContainer";
import { Paths,Urls } from "../../constants/UrlConstants";
import MakeAClaimButton from "./../../components/shared/buttons/MakeAClaimButton";
import PromoImageCard from "./../../components/shared/PromoImageCard";
import { getLayout } from "../../layout/Layout";
import { Layouts } from "../../constants/Constants";
import DateHelper from "../../helpers/DateHelper";
import MemberHelper from "../../helpers/MemberHelper";
import ClaimsConditionContainer from "./ClaimsConditionContainer";
import Scroll from "react-scroll";
import { Claims_Updates } from "../polices/PolicyConstants";
import ClaimsConditionMobileRow from "./ClaimsConditionMobileRow";

export const mapStateToClaims = (state) => {
  const selectedPolicy = state.policyReducer && state.policyReducer.selectedPolicy;
  const loggedInMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    selectedPolicy
  );
  const isAgeAbove18 = DateHelper.isAgeAbove18(loggedInMember.DateOfBirth);
  return {
    membershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    isAgeAbove18,
    isFormat2: selectedPolicy && selectedPolicy.IsFormat2,
    isInternational: selectedPolicy && selectedPolicy.IsInternational,
    claimMembers:
      state.claimsReducer.selectedPolicy &&
      state.claimsReducer.selectedPolicy.claimMembers,
    selectedClaimMember:
      state.claimsReducer.selectedPolicy &&
      state.claimsReducer.selectedPolicy.selectedClaimMember,
    Members: selectedPolicy && selectedPolicy.Members,
    isLapsed : selectedPolicy && selectedPolicy.IsLapsed,
    memberplanId: state.claimsReducer.selectedPolicy && state.claimsReducer.selectedPolicy.SFMemberDetails &&
        state.claimsReducer.selectedPolicy.SFMemberDetails.memberplanId,
    memberDetails : state.claimsReducer.selectedPolicy && state.claimsReducer.selectedPolicy.SFMemberDetails &&
        state.claimsReducer.selectedPolicy.SFMemberDetails.memberDetails,
    claimCondition: state.claimsReducer.selectedPolicy && state.claimsReducer.selectedPolicy.SFclaimCondition,
    featureFlagEP: state.unreadMessagesReducer && state.unreadMessagesReducer.featureFlagEP,
    IsInternalView: state.policyReducer && state.policyReducer.policyDetails && state.policyReducer.policyDetails.IsInternalView,
  };
};

function selectedMemberHasConditions(member) {
  return member.Conditions && member.Conditions.length > 0;
}

function getDropDownItemsFromMembers(members, selectedMember) {
  return members.map((m) => {
    return {
      Name: m.Name,
      Value: m.SecurityId,
      DefaultSelected:
        !!selectedMember && m.SecurityId === selectedMember.SecurityId
    };
  });
}

class Claims extends Component {
  static content = Store.Claims;

  constructor(props) {
    super(props);
    this.state = {
      claimMembers: [],
      isLoading: true,
      url:Urls.EngagementPortal[EPDomain_ROOT].messages,
      Authurl:Urls.EngagementPortal[EPDomain_ROOT].preauth,
      ClaimBackUrl : Urls.EngagementPortal[EPDomain_ROOT].claimBackPayment,
      sortedData: [],
      visibleClaimConditionData: [],
      currentIndex: 0,
      sortedDataInvoice:[],
      visibleClaimInvoiceData:[],
      currentIndexInvoice:0,
      claimsInvoiceData:[],
      initialLoadDataCount:5,
      isMobileDevice:false,
      isTabletDevice:false,
      claimsConditionArray:[],
      isPolicyHolder:false,
      OADView:false,
      isOADAvailable:false,
      isUADAvailable:false,
      userAvailableInSF:true,
    };
    this.onClaimMemberChange = this.onClaimMemberChange.bind(this);
    this.callService = this.callService.bind(this);
    this.initializeClaimConditionData = this.initializeClaimConditionData.bind(this);
    this.initializeClaimInvoiceData = this.initializeClaimInvoiceData.bind(this);
    this.identifyLoggedInMember = this.identifyLoggedInMember.bind(this);
  }

  
componentDidUpdate(prevProps) {

    if (prevProps.claimCondition !== this.props.claimCondition) {      
      this.initializeClaimConditionData(this.props.claimCondition);
    }
    if(prevProps.selectedClaimMember !== this.props.selectedClaimMember){
      this.initializeClaimInvoiceData(this.props.selectedClaimMember?.Conditions);
    }
  }

  initializeClaimInvoiceData = (data) =>{
    if (!data || data.length === 0) return;

            // const sortedDataInvoice = [...data].sort(
            //   (a, b) => new Date(b.LastUpdatedDate) - new Date(a.LastUpdatedDate)
            // );
          if(!this.props.isFormat2)
          {
              this.setState({
                visibleClaimInvoiceData: data,
              });
          }
          else{
            const sortedDataInvoice=data;

            let initialLoadData = data.length >=this.state.initialLoadDataCount ? this.state.initialLoadDataCount : data.length;

            this.setState({
              sortedDataInvoice,
              visibleClaimInvoiceData: sortedDataInvoice.slice(0, initialLoadData),
              currentIndexInvoice: initialLoadData,
            });
          }
    }

  initializeClaimConditionData = (data) =>{
    
    if (!data || data.length === 0) return;

        const sortedData = [...data].sort(
          (a, b) => new Date(b.LastUpdatedDate) - new Date(a.LastUpdatedDate)
        );

        let initialLoadData = data.length >=this.state.initialLoadDataCount ? this.state.initialLoadDataCount : data.length;

        this.setState({
          sortedData,
          visibleClaimConditionData: sortedData.slice(0, initialLoadData),
          currentIndex: initialLoadData,
        });
      }

  
handleLoadMore = () => {
    const { sortedData, currentIndex } = this.state;
    const nextIndex = currentIndex + 5;
    const nextItems = sortedData.slice(currentIndex, nextIndex);

    this.setState(prevState => ({
      visibleClaimConditionData: [...prevState.visibleClaimConditionData, ...nextItems],
      currentIndex: sortedData.length >= nextIndex?nextIndex:sortedData.length,
    }));
  };

  handleLoadMoreInvoice = () => {
    const { sortedDataInvoice, currentIndexInvoice } = this.state;
    const nextIndex = currentIndexInvoice + 5;
    const nextItems = sortedDataInvoice.slice(currentIndexInvoice, nextIndex);

    this.setState(prevState => ({
      visibleClaimInvoiceData: [...prevState.visibleClaimInvoiceData, ...nextItems],
      currentIndexInvoice: sortedDataInvoice.length >= nextIndex?nextIndex:sortedDataInvoice.length,
    }));
  };


  async onClaimMemberChange(securityId) {
    if(this.props.isFormat2)
    {
        if(this.props.memberDetails?.PolicyMembers?.length>0){
        const selectedMemberDropDown = this.props.Members?.find(obj => obj.SecurityId === securityId);
        let selectedMemberDetail = this.props.memberDetails?.PolicyMembers.find(obj=>obj.MemberSourceSystemId === selectedMemberDropDown.ClientId);
        if(selectedMemberDetail === undefined || selectedMemberDetail === null){
          selectedMemberDetail = (this.props.memberDetails.MemberSourceSystemId === selectedMemberDropDown.ClientId) ? this.props.memberDetails : null;
        }
        if(selectedMemberDetail === undefined || selectedMemberDetail === null){
          this.setState({userAvailableInSF: false});
        }
        if(selectedMemberDetail !== undefined && selectedMemberDetail !== null) {
          this.setState({userAvailableInSF: true});
          await this.props.setClaimCondition(this.props.membershipNumber, selectedMemberDetail?.MemberPlanId, this.props.history);
        }
        
      }
      else{
        this.setState({userAvailableInSF: false});
      }
    }
    
    await this.props.setClaimSummaryForMember(
      this.props.membershipNumber,
      securityId,
      this.props.history
    );
  }

    identifyLoggedInMember(){
      let isPolicyHolder = false;
      let isUADAvailable = false;
      let isOADAvailable = false;
      let OADView = false;
       if (this.props.Members != null) {
          for (var i = 0; i < this.props.Members.length; i++) {

            if(!isPolicyHolder)
            {
              isPolicyHolder=this.props.Members[i]?.IsLoggedInMember && this.props.Members[i]?.IsPolicyHolder;
            }
            if(!isUADAvailable)
            {
              isUADAvailable = !this.props.Members[i]?.IsOverageDependant && !this.props.Members[i]?.IsLoggedInMember;
            }
            if(!isOADAvailable){
              isOADAvailable = this.props.Members[i]?.IsOverageDependant && !this.props.Members[i]?.IsLoggedInMember;
            }
            if(!OADView){
              OADView = this.props.Members[i]?.IsLoggedInMember && !this.props.Members[i]?.IsPolicyHolder;
            }

          }
          this.setState({
              isPolicyHolder:isPolicyHolder,
              isUADAvailable:isUADAvailable,
              isOADAvailable:isOADAvailable,
              OADView:OADView
            });
        }
    }
  async callService(){
      if(this.props.memberplanId !== null && this.props.memberplanId !== undefined && this.props.isFormat2 )
      {
        await this.props.setClaimCondition(this.props.membershipNumber,this.props.memberplanId,this.props.history);
      }
    }

  async componentDidMount() {
    if (this.props.membershipNumber) {
      if(this.props.isFormat2)
      {
        if(this.props.selectedClaimMember===null || this.props.selectedClaimMember===undefined)
        {
          await this.props.getMemberDetails(this.props.membershipNumber, this.props.history);
          this.callService();
        }
        else{
          this.onClaimMemberChange(this.props.selectedClaimMember?.SecurityId);
        }
        
      }
      
      await this.props.setClaimMembers(
        this.props.membershipNumber,
        this.props.history
      );
      
      this.identifyLoggedInMember();
    }
    if (this.props.claimMembers.length > 0) {
      let selectedMember = this.props.selectedClaimMember;
      if (!this.props.selectedClaimMember) {
        selectedMember = this.props.claimMembers[0];
      }
      await this.props.setClaimSummaryForMember(
        this.props.membershipNumber,
        selectedMember.SecurityId,
        this.props.history
      );
    }
    this.initializeClaimConditionData(this.props.claimCondition);
    
    if(this.props.selectedClaimMember !== null && this.props.selectedClaimMember !== undefined)
    {
        this.initializeClaimInvoiceData(this.props.selectedClaimMember?.Conditions);
    }

    let isMobile = window.matchMedia(Breakpoints.smDown);
    let isTablet = window.matchMedia(Breakpoints.tablet);
    
    this.setState({
      isLoading: false,
      claimsInvoiceData:this.props.selectedClaimMember?.Conditions,
      initialLoadDataCount:isMobile.matches ? 3 : 5 ,
      isMobileDevice: isMobile.matches?true:false,
      isTabletDevice: isTablet.matches?true:false,
    });
  }

  handleCallback=(childData)=>{
    this.setState({ url: childData });
  }

  handleAuthCallback = (childData) => {
    this.setState({ Authurl: childData });
  };

  handleClaimCallback = (childData) => {
    this.setState({ ClaimBackUrl: childData });
  };


  render() {
    const claimsContent = this.props.content;

    let claimsConditionContent=claimsContent.ClaimsSectionCrestBody(this.state.url);
    
    let selectedMember = this.props.selectedClaimMember;
   
    const allDataLoaded = this.state.currentIndex >= this.state.sortedData.length;

    const allInvoiceDataLoaded = this.state.currentIndexInvoice >= this.state.sortedDataInvoice.length;

    let claimsSummarySection;
    let claimsConditionSection;
    if (this.state.isLoading) {
      claimsConditionSection=(<div className={`row ${style.rowAlignmentMobile}`}>
            {claimsContent.LoadingMessage}
      </div>);
      claimsSummarySection=claimsContent.LoadingMessage;
    } 
    else 
    {
        if(this.props.claimCondition && this.props.claimCondition?.length>0 && this.props.isFormat2
          && this.state.userAvailableInSF)
        {
              if(this.state.isMobileDevice){
                  claimsConditionSection=this.state.visibleClaimConditionData?.map((condition, index) =>(
                                        <ClaimsConditionMobileRow
                                        key={index}
                                        claimscondition={condition}
                                        isFormat2={this.props.isFormat2}
                                        isMobileDevice = {this.state.isMobileDevice}
                                        />
                                      )
                    );
                
              }
              else{
                    claimsConditionSection=this.state.visibleClaimConditionData?.map((condition, index) =>(
                      <ClaimsConditionContainer
                      key={index}
                      claimscondition={condition}
                      isFormat2={this.props.isFormat2}
                      isMobileDevice = {this.state.isMobileDevice}
                      isTabletDevice = {this.state.isTabletDevice}
                      />
                    )
                  );
                }
        }
      else{
        claimsConditionSection = (<div className={`row ${this.state.isMobileDevice||this.state.isTabletDevice?style.rowAlignmentMobile:""}`}>
        <div className={"col-1  " + claimRowStyle.paddingRightForIcon}>
         <i
                    className={
                      "icon-claims-shield " +
                      claimRowStyle.claimRowIcon +
                      " " +
                      claimRowStyle.floatIconRight
                    }/>
        </div>
        <div className={`col-11 ${this.state.isMobileDevice?"":style.claimsInvoice}`}>
        <p className={style.noclaims}>{claimsContent.TextForNoClaimsConditions}</p>
        </div>
        </div>
      );
      }
      if (selectedMember && selectedMemberHasConditions(selectedMember)) {
          claimsSummarySection = this.state.visibleClaimInvoiceData?.map(
            (condition, index) => (
              <ClaimsSummaryContainer
                key={index}
                claimSummary={condition}
                isFormat2={this.props.isFormat2}
                membershipNumber={this.props.membershipNumber}
              />
            )
          );
      }
     else {
        claimsSummarySection = (<div className={`row ${this.state.isMobileDevice||this.state.isTabletDevice?style.rowAlignmentMobileInvoice:""}`}>
          <div className={"col-1 " + claimRowStyle.paddingRightForIcon}>
          <i
                      className={this.props.isFormat2?
                        "icon-claims-document " : "icon-functional-document "+
                        claimRowStyle.claimRowIcon +
                        " " +
                        claimRowStyle.floatIconRight
                      }
                    />
                    </div>
                    <div className={`col-11 ${this.state.isMobileDevice||this.state.isTabletDevice?style.claimsInvoiceMobile:""}`}>
                    <p className={style.noclaims}>{claimsContent.TextForNoClaimsSummary}</p>
                    </div>
                    </div>
          );
      }
    }
    let OADMessageSection=""; 
    // var ageFlag = true;
    if (this.props.Members != null) {
      // for (var i = 0; i < this.props.Members.length; i++) {
      //   var today = new Date();
      //   var birthDate = new Date(this.props.Members[i].DateOfBirth);
      //   var age = today.getFullYear() - birthDate.getFullYear();
      //   var m = today.getMonth() - birthDate.getMonth();
      //   if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      //     age--;
      //   }
      //   if (age > 16) {
      //     ageFlag = true;
      //   }
      //   else {
      //     ageFlag = false;
      //     OADMessageSection = null;
      //     break;
      //   }

        // if (ageFlag === true) {
        if (this.state.isPolicyHolder && this.state.isOADAvailable && this.state.isUADAvailable === false) {
            OADMessageSection = (
              <div className="OAD-message-style">
                {claimsContent.ViewClaimsToolTipOAD}
              </div>);
          }
          else if (this.state.OADView) {
            OADMessageSection = (
              <div className="OAD-message-style">
                {claimsContent.ViewClaimsToolTipOADloggedin}
              </div>);
      }
      //   }
      // }
    }

    return (
      <div className={style.claims}>
        <ShadowedContainer>
          <div className="row">
            <div className={"col-lg-8 " + style.articleDescription}>
              <Article
                header={claimsContent.MyClaimsSection.Header}
                body={claimsContent.MyClaimsSection.Body}
              />
            </div>
            <div
              className={
                "text-right col-lg-4 d-block d-sm-block d-md-block " +
                (this.props.isFormat2 ? this.state.isMobileDevice || this.state.isTabletDevice ?
                 style.articleWithButtonPadding: " " : style.articleWithButtonPadding)
              }
            >
              <MakeAClaimButton />
            </div>
          </div>

          {this.props.isFormat2? " " :<hr />}
          <EPQueryParams url={this.state.url} updatedURL={this.handleCallback}/> 
          <EPQueryParams url={this.state.Authurl} updatedURL={this.handleAuthCallback}/>
          <EPQueryParams url={this.state.ClaimBackUrl} updatedURL={this.handleClaimCallback}/> 
          <div className="row">
            <div className={style.articleDescriptionSection3 + " col-lg-9"}>
              <Article
                header={claimsContent.AllClaimsSection.Header}
                body={claimsContent.AllClaimsSection.Body}
              />
            </div>
            <div className={"col-lg-12 mb-3 " + style.noMarginTop}>                
                <div className="row">
                  {this.props.claimMembers.length > 1  && this.state.isPolicyHolder && this.state.isUADAvailable? (
                  <>
                  <div className="col-lg-5">
                    <DropDown
                      id="SelectClaimsFor"
                      label={
                        <Content name={claimsContent.ViewClaimsForLabel} />
                      }
                      onChange={this.onClaimMemberChange}
                      items={getDropDownItemsFromMembers(
                        this.props.claimMembers,
                        this.props.selectedClaimMember
                      )}
                    />
                  </div>
                  <div
                    className={
                      "tooltipContent input-tooltip " + style.tooltipMargin
                    }
                  >
                    {claimsContent.ViewClaimsToolTip}
                  </div></>
                  ) : null}
                 {OADMessageSection !== ""?( <div className={this.props.isFormat2?style.tooltipMargin:style.dependentMessageBox}>
                    {OADMessageSection}
                  </div>):null}
                </div>
            </div>
            {this.props.isFormat2 && (<div
              className={
                "col-12 " + style.invoiceMargin
              }
            >
            <div>
              <div className={style.articleDescriptionSection3}>
                <Article
                  header={claimsContent.ClaimsSectionCrestHeader}
                  body={claimsConditionContent[0].Content}
                />
              </div>
            </div>
            <div className={claimRowStyle.rowTopMargin}>
            <button className={style.scrolldownButton}
                   onClick={() => {
                                         Scroll.scroller.scrollTo(Claims_Updates, {
                                           duration: 750,
                                           smooth: true
                                         });
                                       }}>
                    {claimsContent.ClaimsSectionCrest.scrollSectionLabel}
            </button>
            </div>
              {claimsConditionSection}
              {this.props.claimCondition?.length>0 && this.state.userAvailableInSF &&
                (<p className={style.showingTextColor}>{claimsContent.ClaimsSectionCrest.showing+" "+(this.state.currentIndex)+" of "+this.props.claimCondition?.length+" claims"}</p>)}
              {!allDataLoaded && this.state.userAvailableInSF && (
                <div className={style.alignLink}>
             <button className={style.loadMoreButton}
                   onClick={this.handleLoadMore}>
                    {claimsContent.ClaimsSectionCrest.LoadMore}
                    </button></div>)}
            </div>)}
              <hr />
              <section className={this.props.isFormat2? "": "col-12"} name={Claims_Updates}>  
            <div
              className={
                "col-12 " +
                (this.props.isFormat2? style.invoiceMargin : this.props.claimMembers.length > 1
                  ? " " + style.dropDownSummaryMargin
                  : "")
              }
            >
              {this.props.isFormat2 && (<div>
            <div className={style.articleDescriptionSection3}>
              <Article
                header={claimsContent.ClaimsUpdateSectionCrest.Header}
                body={claimsContent.ClaimsUpdateSectionCrest.Body}
              />
            </div>
            </div>)}
              {claimsSummarySection}
              {this.props.isFormat2 && this.props.selectedClaimMember?.Conditions?.length>0 &&
                (<p className={style.showingTextColor}>{claimsContent.ClaimsSectionCrest.showing+" "+(this.state.currentIndexInvoice)+" of "+this.props.selectedClaimMember?.Conditions?.length+" claims"}</p>)}
              {!allInvoiceDataLoaded && this.props.isFormat2 && (
             <div className={style.alignLink}>
             <button className={style.loadMoreButton}
                   onClick={this.handleLoadMoreInvoice}>
                    {claimsContent.ClaimsSectionCrest.LoadMore}
                    </button></div>)}
            </div>
            </section>
          </div>

          <hr />
          {!this.props.isFormat2 &&
          (<>
          <div className="row">
            <div className={style.articleDescriptionSection2 + " col-lg-9"}>
              <Article
                header={claimsContent.RecentlySubmittedSection.Header}
                body={claimsContent.RecentlySubmittedSection.Body}
              />
            </div>
            <div className="col-lg-12">
              <Button
                label={claimsContent.GoToInboxLabel}
                buttonType="secondaryBlueButton"
                onClick={() => {
                  if(this.props.featureFlagEP === false || this.props.featureFlagEP === undefined){
                  this.props.history.push(Paths.Inbox);
                  }else if(this.props.featureFlagEP === true ){
                    window.open(this.state.url, "_blank", "noopener");
                  }
                }}
                disabled={this.props.IsInternalView}
                IsInternalView={this.props.IsInternalView}
              />
            </div>
          </div>

          <hr /> </>)}
          
          <div className="row">
            <div className="col-lg-12">
              {/* <div className="d-none d-sm-block d-md-none d-block d-sm-none">
                <p>
                  <Content
                    name={claimsContent.AllClaimsSection.GetStartedText}
                  />
                </p>
                <MakeAClaimButton />
              </div> */}
              <div className={style.helpSection}>
                <HelpSection
                  HeadingLinkTo={claimsContent.HelpSection.HeadingLinkTo}
                  HeadingLinkText={claimsContent.HelpSection.HeadingLinkText}
                  MoreHelpLinkTo={claimsContent.HelpSection.MoreHelpLinkTo}
                  MoreHelpLinkText={claimsContent.HelpSection.MoreHelpLinkText}
                  HelpSet={
                    this.props.featureFlagEP === false || this.props.featureFlagEP === undefined ?
                    claimsContent.HelpSet :
                    claimsContent.HelpSetEP(this.state.Authurl, this.state.ClaimBackUrl,this.props.IsInternalView)}
                />
              </div>
            </div>
          </div>
        </ShadowedContainer>
        <PromoContainer>
          {/* <PromoImageCard
            IsExternalLink={this.props.isInternational}
            LinkTo={claimsContent.Promo.LinkTo}
            LinkText={claimsContent.Promo.LinkText}
            LeftImage
            ImgSrc={claimsContent.Promo.ImgSrc}
            ImgSrcMobile={claimsContent.Promo.ImgSrcMobile}
            Heading={claimsContent.Promo.Heading}
            Description={claimsContent.Promo.Description}
          /> */}
           {!this.props.isLapsed && (this.props.isAgeAbove18 ? <MskSection accessPage={Paths.Claims} UniqueKey="mskBanner"  />:
           (
            <PromoImageCard
            ImgSrc={Store.PromoCards.AccessHealthSupportSrc.IconSrc}
            ImgSrcMobile={
              Store.PromoCards.AccessHealthSupportSrc.IconSrcMobile
            }
            Heading={Store.PromoCards.AccessHealthSupportSrc.Heading}
            Description={
              Store.PromoCards.AccessHealthSupportSrc.Description
            }
            LinkText={Store.PromoCards.AccessHealthSupportSrc.LinkText}
            LinkTo={getLayout()===Layouts.HOL ?  Store.PromoCards.AccessHealthSupportSrc.LinkToHOL : Store.PromoCards.AccessHealthSupportSrc.LinkTo}
            LeftImage
          />
          ))}
        </PromoContainer>
      </div>
    );
  }
}

export default withRouter(
  connect(mapStateToClaims, { setClaimMembers, setClaimSummaryForMember, setClaimCondition, getMemberDetails })(
    Contentify(Claims)
  )
);
